import React, { useEffect, useRef } from 'react'

declare global {
  interface HubspotWindow extends Window {
    hbspt: {
      forms: {
        create: (options: any) => void
      }
    }
  }
}

interface HubSpotFormProps {
  setShowTitle: (show: boolean) => void
  source: string
}

const HubSpotForm = ({ setShowTitle, source }: HubSpotFormProps) => {
  const formInitialized = useRef(false)

  useEffect(() => {
    if (formInitialized.current) return

    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    script.async = true
    document.body.appendChild(script)

    script.onload = () => {
      const myWindow: HubspotWindow = window as unknown as HubspotWindow

      if (myWindow.hbspt) {
        myWindow.hbspt.forms.create({
          region: 'na1',
          portalId: '5228455',
          formId:
            source === 'upgrade'
              ? '57640915-2928-4694-adef-0ee2f1cfa72d'
              : '20ff3545-dea4-46f5-94c1-21592d88df7c',
          target: '.hubspot_form',
          onFormSubmitted: () => {
            setShowTitle(false)
          },
        })
        formInitialized.current = true
      }
    }

    return () => {
      document.body.removeChild(script)
    }
  }, [source, setShowTitle])

  return <div className="hubspot_form"></div>
}

export default HubSpotForm
